import React from 'react';

const wrapStyle = {
  position: 'absolute',
  top: 0, left: 0, right: 0, bottom: 0,
  width: '100%', height: '100%',
  background: 'rgba(255, 255, 255, 0.75)',
  backdropFilter: 'blur(3px)',
  zIndex: 999,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '14px',
};

const spinStyle = {
  width: '48px',
  height: '48px',
  border: '4px solid rgba(48, 221, 251, 0.2)',
  borderTopColor: '#30ddfb',
  borderRadius: '50%',
  animation: 'cgt-spin 0.75s linear infinite',
};

const labelStyle = {
  fontFamily: 'Poppins, sans-serif',
  fontSize: '0.75rem',
  fontWeight: 600,
  color: '#1d3c53',
  letterSpacing: '2px',
  textTransform: 'uppercase',
};

// Inject keyframe once
if (typeof document !== 'undefined' && !document.getElementById('cgt-spin-style')) {
  const s = document.createElement('style');
  s.id = 'cgt-spin-style';
  s.textContent = '@keyframes cgt-spin { to { transform: rotate(360deg); } }';
  document.head.appendChild(s);
}

function Loader2() {
  return (
    <div style={wrapStyle}>
      <div style={spinStyle} />
      <span style={labelStyle}>Loading...</span>
    </div>
  );
}

export default Loader2;